var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('main-layout',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('alert-box')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }